import React from 'react'
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';

const AlertModal = ({show, title, text, onClose}) => {
    return (
        <Modal show={show} onHide={onClose}>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>

            <Modal.Body>{text}</Modal.Body>

            <Modal.Footer>
                <Button className="btn-light btn-sm" onClick={onClose}>Ok</Button>
            </Modal.Footer>
        </Modal>
    )
};

export default AlertModal;
